/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { Box, IconButton } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircleOutline";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { TooltipV1 } from "@startree-ui/platform-ui";
import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

export const CopyIconButton: FunctionComponent<{
    text: string;
    tooltip?: string;
}> = ({ text, tooltip }) => {
    const [copied, setCopied] = useState(false);
    const { t } = useTranslation();

    const handleClipboardCopyClick = (
        event: React.MouseEvent<HTMLButtonElement>
    ): void => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);

        event.stopPropagation();
    };

    return (
        <Box className="copy-icon-button">
            {!copied && (
                <TooltipV1
                    delay={0}
                    placement="top"
                    title={tooltip || t("label.copy")}
                >
                    <IconButton size="small" onClick={handleClipboardCopyClick}>
                        <FileCopyOutlinedIcon
                            fontSize="small"
                            style={{ width: "16px", height: "16px" }}
                        />
                    </IconButton>
                </TooltipV1>
            )}
            {copied && (
                <TooltipV1 delay={0} placement="top" title={t("label.copied")}>
                    <IconButton
                        size="small"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <CheckCircleIcon
                            color="primary"
                            fontSize="small"
                            style={{ width: "16px", height: "16px" }}
                        />
                    </IconButton>
                </TooltipV1>
            )}
        </Box>
    );
};
